import { render, staticRenderFns } from "./SSelectPayment.vue?vue&type=template&id=260f8e18"
import script from "./SSelectPayment.vue?vue&type=script&lang=js"
export * from "./SSelectPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports